import { formatAzureBlob } from "../../../components/formatted/FormattedAzureSasToken";

// Same rewrite as the photo reader in ImageTreatment: -R/-L first, then a
// plain .jpeg (single-camera pictures have no side suffix).
export const buildOutputSurfaceBlobUrl = (historyItem) => {
  if (!historyItem?.image_url || !historyItem?._measurement) return null;
  const measurement = historyItem._measurement;
  return formatAzureBlob(
    historyItem.image_url
      .replace("pictures", "output-surface")
      .replace("-R.jpeg", "-" + measurement + "-surface.json")
      .replace("-L.jpeg", "-" + measurement + "-surface.json")
      .replace(".jpeg", "-" + measurement + "-surface.json"),
  );
};
